import { render } from "./CreateAsset.vue?vue&type=template&id=31f177ee&scoped=true"
import script from "./CreateAsset.vue?vue&type=script&lang=js"
export * from "./CreateAsset.vue?vue&type=script&lang=js"

import "./CreateAsset.vue?vue&type=style&index=0&id=31f177ee&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f177ee"]])

export default __exports__